/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Try_Magic_More_Voices_LanguagesInputs */

const en_try_magic_more_voices_languages = /** @type {(inputs: Try_Magic_More_Voices_LanguagesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} language, accents and styles`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} languages, accents and styles`);
	return /** @type {LocalizedString} */ ("try_magic_more_voices_languages");
};

const es_try_magic_more_voices_languages = /** @type {(inputs: Try_Magic_More_Voices_LanguagesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} idioma, acentos y estilos`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} idiomas, acentos y estilos`);
	return /** @type {LocalizedString} */ ("try_magic_more_voices_languages");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} language, accents and styles" |
* | "other" | "{count} languages, accents and styles" |
*
* @param {Try_Magic_More_Voices_LanguagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_more_voices_languages = /** @type {((inputs: Try_Magic_More_Voices_LanguagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_More_Voices_LanguagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_more_voices_languages(inputs)
	return en_try_magic_more_voices_languages(inputs)
});